import { render, staticRenderFns } from "./BlackFooter.vue?vue&type=template&id=f27db496&scoped=true"
import script from "./BlackFooter.vue?vue&type=script&lang=js"
export * from "./BlackFooter.vue?vue&type=script&lang=js"
import style0 from "./BlackFooter.vue?vue&type=style&index=0&id=f27db496&prod&lang=scss"
import style1 from "./BlackFooter.vue?vue&type=style&index=1&id=f27db496&prod&lang=scss&scoped=true"
import style2 from "./BlackFooter.vue?vue&type=style&index=2&id=f27db496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27db496",
  null
  
)

export default component.exports